module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recalculate":"Recalculate KPIs"},"de":{"recalculate":"Neuberechnen"}}')
  delete Component.options._Ctor
}
